import React from 'react';
import {Redirect,Route } from 'react-router-dom';
import sessionService from '../services/sessionService';
//Private router function
export const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={props =>
          sessionService.isAuth() !== false ? (
            <Component {...props} />
          ) : (
            <Redirect to="/" />
          )}
      />
    );
  };


// WEBPACK FOOTER //
// ./src/privateRoute/privateRoute.js